import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';

@Injectable()
export class CountryService {
    // resource = './countryCode.json';
    constructor(private http: Http) {

    }
    getCountry() { // Get Forex Rates Alerts
        return this.http.get('./assets/countryCode.json').map(res => res)
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/country/country.service.ts